module.exports = __webpack_public_path__ + "img/Marca18.5e9ef29f.jpg";